import React from 'react';
// import PopTopWinersIstoric from './PopTopWinersIstoric';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acConSizeChange } from '../actions/acConSizeChange'


class TopWiners extends React.Component {

    constructor() {
        super();
        this.state = {
            active: 'saptamanal',
            past: 'last',
        }
    }
    componentDidMount() {
        this.axios({ period: 'saptamanal', time: 'last' });
        // this.axios({ period: 'week', time: 'last' });
        if (this.refTopW) {
            var dimensions = this.refTopW
            if (dimensions.offsetHeight) {
                this.props.acConSizeChange({ topWiners: dimensions.offsetHeight })
            }
        }
    }
    componentDidUpdate(nextProps) {
        if (this.refTopW) {
            var heightTopWidget = this.refTopW.offsetHeight
            if (heightTopWidget && this.props.conSizeChange.topWiners && this.props.conSizeChange.topWiners !== heightTopWidget) { //109 - h min a top widgetului
                this.props.acConSizeChange({ topWiners: heightTopWidget })
            }
        }
    }
    axios(val) {
        var serverTime = {
            ruta: this.props.appProps.ruta,
            request: 'top_chart_info',
            reducer: 'TOP_WINER',
            value: 'period=' + val.period + '&time=' + val.time,
            loading: true,
            error: '7000',
            newParam: this.props.sessionParam
        }
        this.props.acAxiosRequest(serverTime);
    }
    classActive(val) {
        if (val === this.state.active) {
            return 'active';
        } else {
            return '';
        }
    }
    changePeriod(val) {
        this.axios({ period: val, time: this.state.past });
        this.setState({ active: val });
    }
    disabledChangePast(val) {
        if (val === this.state.past) {
            return true
        } else {
            return false
        }
    }
    topWinerPast() {
        var time = ''

        if (this.state.past !== 'last') {
            if (this.state.active === 'saptamanal') {
                time = this.props.multiLang.thisWeek.txt
            } else if (this.state.active === 'lunar') {
                time = this.props.multiLang.thisMonth.txt
            } else if (this.state.active === 'anual') {
                time = this.props.multiLang.thisYear.txt
            }
        } else {
            if (this.state.active === 'saptamanal') {
                time = this.props.multiLang.lastWeek.txt
            } else if (this.state.active === 'lunar') {
                time = this.props.multiLang.lastMonth.txt
            } else if (this.state.active === 'anual') {
                time = this.props.multiLang.lastYear.txt
            }
        }
        return (
            <div>{time}</div>
        )
    }
    changePast(val) {
        this.axios({ period: this.state.active, time: val });
        this.setState({ past: val });
    }
    loadingActive() {
        if (this.props.loading === 'TOP_WINER') {
            return 'active sk-circle'
        } else {
            return ''
        }
    }
    render() {
        // console.log("topWiner", this.state.height, this.props.conSizeChange.colDr)
        // console.log("topwin",this.props )
        //this.props.topWiner = true;
        if (this.props.topWiner !== null) {
            if ((this.props.topWiner.status !== "error") && (this.props.topWiner.length !== 0) && (this.props.topWiner.value !== ("list is empty"))) {
                var odds, castig_txt = ''
                if (this.props.conSizeChange.appW >= 1000 && this.props.conSizeChange.appW <= 1169) {
                    castig_txt = this.props.multiLang.castig.txt + ': '
                }
                // if ((this.props.conSizeChange.appW < 1000) || (this.props.conSizeChange.appW >= 1169 && this.props.conSizeChange.appW <= 1550)) {
                //     // odds = 'x'
                //     odds = this.props.multiLang.cotaTopWinners.txt + ': '
                // } else {
                //     odds = this.props.multiLang.cotaTopWinners.txt + ': '
                // }
                if (this.props.multiLang.cotaTopWinners.txt === 'x') {
                    odds = this.props.multiLang.cotaTopWinners.txt
                } else {
                    odds = this.props.multiLang.cotaTopWinners.txt + ': '
                }
                return (
                    <div ref={(f) => this.refTopW = f} className="con-top-winers">
                        <div className="top-winers-header module-header">{this.props.multiLang.lotWinners.txt}</div>
                        <div className="top-winers-timeframe">
                            <div className={this.classActive('saptamanal')} onClick={this.changePeriod.bind(this, 'saptamanal')}>{this.props.multiLang.weekly.txt}</div>
                            <div className={this.classActive('lunar')} onClick={this.changePeriod.bind(this, 'lunar')}>{this.props.multiLang.monthly.txt}</div>
                            <div className={this.classActive('anual')} onClick={this.changePeriod.bind(this, 'anual')}>{this.props.multiLang.annual.txt}</div>
                        </div>
                        <div className="top-winers-past">
                            {/* ◀ ▶*/}
                            <button onClick={this.changePast.bind(this, 'last')} disabled={this.disabledChangePast('last')}></button>
                            {this.topWinerPast()}
                            <button onClick={this.changePast.bind(this, 'this')} disabled={this.disabledChangePast('this')}></button>
                        </div>
                        <div className="top-winers-mid">
                            <div className={"loading " + this.loadingActive()}>
                                <div className="sk-circle1 sk-child"></div>
                                <div className="sk-circle2 sk-child"></div>
                                <div className="sk-circle3 sk-child"></div>
                                <div className="sk-circle4 sk-child"></div>
                                <div className="sk-circle5 sk-child"></div>
                                <div className="sk-circle6 sk-child"></div>
                                <div className="sk-circle7 sk-child"></div>
                                <div className="sk-circle8 sk-child"></div>
                                <div className="sk-circle9 sk-child"></div>
                                <div className="sk-circle10 sk-child"></div>
                                <div className="sk-circle11 sk-child"></div>
                                <div className="sk-circle12 sk-child"></div>
                            </div>
                            {
                                this.props.topWiner.map((val, i) => {
                                    return (
                                        <div key={i} className="top-winers-mid-item">
                                            <div className={"img top-winer" + i}></div>
                                            <div>
                                                <span className="user">{val.username}</span>
                                                <span className="miza">{this.props.multiLang.stake.txt + ': ' + val.money_in}</span>
                                                <span>{this.props.multiLang.loteria.txt + ': '}{val.lottery_name}</span>
                                            </div>
                                            <div>
                                                <span className="castig">{castig_txt + val.money_out}</span>
                                                <span>{odds + val.odds}</span>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            } else {
                //exista partial

                return (
                    ///nu exista
                    <div className="con-top-winers" ref={(f) => this.refTopW = f} >
                        <div className="top-winers-header module-header">{this.props.multiLang.lotWinners.txt}</div>
                        <div className="top-winers-timeframe">
                            <div className={this.classActive('saptamanal')} onClick={this.changePeriod.bind(this, 'saptamanal')}>{this.props.multiLang.weekly.txt}</div>
                            <div className={this.classActive('lunar')} onClick={this.changePeriod.bind(this, 'lunar')}>{this.props.multiLang.monthly.txt}</div>
                            <div className={this.classActive('anual')} onClick={this.changePeriod.bind(this, 'anual')}>{this.props.multiLang.annual.txt}</div>
                        </div>
                        <div className="top-winers-past">
                            {/* ◀ ▶*/}
                            <button onClick={this.changePast.bind(this, 'last')} disabled={this.disabledChangePast('last')}></button>
                            {this.topWinerPast()}
                            <button onClick={this.changePast.bind(this, 'this')} disabled={this.disabledChangePast('this')}></button>
                        </div>
                        <div className="top-winers-mid">
                            <div className={"loading " + this.loadingActive()}>
                                <div className="sk-circle1 sk-child"></div>
                                <div className="sk-circle2 sk-child"></div>
                                <div className="sk-circle3 sk-child"></div>
                                <div className="sk-circle4 sk-child"></div>
                                <div className="sk-circle5 sk-child"></div>
                                <div className="sk-circle6 sk-child"></div>
                                <div className="sk-circle7 sk-child"></div>
                                <div className="sk-circle8 sk-child"></div>
                                <div className="sk-circle9 sk-child"></div>
                                <div className="sk-circle10 sk-child"></div>
                                <div className="sk-circle11 sk-child"></div>
                                <div className="sk-circle12 sk-child"></div>
                            </div>
                            {
                                this.props.topWiner && !this.props.topWiner.value ?
                                    this.props.topWiner.map((val, i) => {
                                        return (
                                            <div key={i} className="top-winers-mid-item">
                                                <div className={"img top-winer" + i}></div>
                                                <div>
                                                    <span className="user">{val.username}</span>
                                                    <span className="miza">{this.props.multiLang.stake.txt + ': ' + val.money_in}</span>
                                                    <span>{this.props.multiLang.loteria.txt + ': '}{val.lottery_name}</span>
                                                </div>
                                                <div>
                                                    <span className="castig">{castig_txt + val.money_out}</span>
                                                    <span>{odds + val.odds}</span>
                                                </div>
                                            </div>
                                        )
                                    }) : null
                            }
                        </div>
                    </div>
                )
                //exista partial
            }
        } else {
            return (
                ///nu exista
                <div className="con-top-winers" ref={(f) => this.refTopW = f} >
                    <div className="top-winers-header module-header">{this.props.multiLang.lotWinners.txt}</div>
                    <div className="top-winers-timeframe">
                        <div className={this.classActive('saptamanal')} onClick={this.changePeriod.bind(this, 'saptamanal')}>{this.props.multiLang.weekly.txt}</div>
                        <div className={this.classActive('lunar')} onClick={this.changePeriod.bind(this, 'lunar')}>{this.props.multiLang.monthly.txt}</div>
                        <div className={this.classActive('anual')} onClick={this.changePeriod.bind(this, 'anual')}>{this.props.multiLang.annual.txt}</div>
                    </div>
                    <div className="top-winers-past">
                        {/* ◀ ▶*/}
                        <button onClick={this.changePast.bind(this, 'last')} disabled={this.disabledChangePast('last')}></button>
                        {this.topWinerPast()}
                        <button onClick={this.changePast.bind(this, 'this')} disabled={this.disabledChangePast('this')}></button>
                    </div>
                    <div className="top-winers-mid">
                        <div className={"loading " + this.loadingActive()}>
                            <div className="sk-circle1 sk-child"></div>
                            <div className="sk-circle2 sk-child"></div>
                            <div className="sk-circle3 sk-child"></div>
                            <div className="sk-circle4 sk-child"></div>
                            <div className="sk-circle5 sk-child"></div>
                            <div className="sk-circle6 sk-child"></div>
                            <div className="sk-circle7 sk-child"></div>
                            <div className="sk-circle8 sk-child"></div>
                            <div className="sk-circle9 sk-child"></div>
                            <div className="sk-circle10 sk-child"></div>
                            <div className="sk-circle11 sk-child"></div>
                            <div className="sk-circle12 sk-child"></div>
                        </div>
                        {
                            this.props.topWiner ?
                                this.props.topWiner.map((val, i) => {
                                    return (
                                        <div key={i} className="top-winers-mid-item">
                                            <div className={"img top-winer" + i}></div>
                                            <div>
                                                <span className="user">{val.username}</span>
                                                <span className="miza">{this.props.multiLang.stake.txt + ': ' + val.money_in}</span>
                                                <span>{this.props.multiLang.loteria.txt + ': '}{val.lottery_name}</span>
                                            </div>
                                            <div>
                                                <span className="castig">{castig_txt + val.money_out}</span>
                                                <span>{odds + val.odds}</span>
                                            </div>
                                        </div>
                                    )
                                }) : null
                        }
                    </div>
                </div>
            )
            //nu exista rezultate
            // return <div></div>
        }
    }
}



function mapStateToProps(state) {
    return {
        topWiner: state.topWiner,
        appProps: state.appProps,
        loading: state.loading,
        multiLang: state.multiLang,
        conSizeChange: state.conSizeChange,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acConSizeChange: acConSizeChange
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(TopWiners);

// export default TopWiners